import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
  },
  section: {
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    fontWeight: "bold",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    padding: 10,
    border: "0.5px solid #DBDBDB",
  },
});

const getColorStatus = (estado, oldEstado) => {
  if (oldEstado === "advertencia") {
    return"#f58b84";
  }

  if (estado === "aprobado") {
    return "#a8f584";
  }

  if (estado === "en proceso") {
    return "#f9f65b";
  }

  return "#f58b84";
};

const DocumentPDF = ({ encuestas }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          {encuestas.map((encuesta) => (
            <View key={encuesta.consecutivo_encuesta} style={styles.article}>
              <View
                style={{
                  ...styles.header,
                  backgroundColor: getColorStatus(encuesta.estado),
                }}
              >
                <Text>{encuesta.fecha}</Text>
                <Text>{encuesta.nombre}</Text>
                <Text>{encuesta.placa}</Text>
                <Text>{encuesta.estado}</Text>
              </View>
              <View style={styles.body}>
                 <View style={styles.section}>
                    <Text>
                      CONSECUTIVO:{" "}
                      {encuesta.consecutivo_encuesta}
                    </Text>
                  </View>
                  <View style={styles.section}>
                    <Text>
                      FECHA:{" "}
                      {encuesta.fecha}
                    </Text>
                  </View>
                   <View style={styles.section}>
                    <Text>
                      ESTADO:{" "}
                      {encuesta.estado}
                    </Text>
                  </View>
                   <View style={styles.section}>
                    <Text>
                      CELULAR:{" "}
                      {encuesta.celular}
                    </Text>
                  </View>
                   <View style={styles.section}>
                    <Text>
                      NOMBRE:{" "}
                      {encuesta.nombre}
                    </Text>
                  </View>
                   <View style={styles.section}>
                    <Text>
                      CEDULA:{" "}
                      {encuesta.cedula}
                    </Text>
                  </View>
                   <View style={styles.section}>
                    <Text>
                      PLACA:{" "}
                      {encuesta.placa}
                    </Text>
                  </View>
                   <View style={styles.section}>
                    <Text>
                      KILOMETRAJE:{" "}
                      {encuesta.kilometraje}
                    </Text>
                  </View>
                {encuesta.respuestas.filter(res => res.id_pregunta > 0).map((res) => (
                  <View key={res.id} style={styles.section}>
                    <Text>
                      {res.pregunta}:{" "}
                      {res.traduccion_respuestas ?? res.respuesta ?? null}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

function PDFInspeccionVehiculos({ encuestas }) {
  return (
    <PDFDownloadLink
      document={<DocumentPDF encuestas={encuestas} />}
      fileName="inspeccion-vehiculos-preoperativo.pdf"
    >
      {({ loading }) =>
        loading ? (
          <button>Generando PDF...</button>
        ) : (
          <button className="btn btn-dark w-100">Descargar PDF</button>
        )
      }
    </PDFDownloadLink>
  );
}

export default PDFInspeccionVehiculos;
